import { render } from "./LeaderboardModal.vue?vue&type=template&id=3b7d957c&scoped=true"
import script from "./LeaderboardModal.vue?vue&type=script&lang=js"
export * from "./LeaderboardModal.vue?vue&type=script&lang=js"

import "./LeaderboardModal.vue?vue&type=style&index=0&id=3b7d957c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7d957c"]])

export default __exports__